import { render, staticRenderFns } from "./ModalDetalleInspeccion.vue?vue&type=template&id=366d9ec7&scoped=true&"
import script from "./ModalDetalleInspeccion.vue?vue&type=script&lang=js&"
export * from "./ModalDetalleInspeccion.vue?vue&type=script&lang=js&"
import style0 from "./ModalDetalleInspeccion.vue?vue&type=style&index=0&id=366d9ec7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366d9ec7",
  null
  
)

export default component.exports